import React from "react";
import Loader from "../../../../../components/Loader";
import Page from "../../../../../components/Page";
import HTTPManager from "../../../../../utils/httpRequestManager";
import TableView from "../../../../../components/table/tableView";
import { ToastContainer } from 'react-toastify';
import FormManager from "../../../../../components/formComponents/FormManager";
import schema from './schema.json';
import { Box, Grid, Card, Container, Stack } from '@mui/material';
import FButton from "../../../../../components/formComponents/components/button";

export default class PayarcSettings extends React.Component {
    httpManager = new HTTPManager();

    constructor() {
        super();
        this.state = {
            isLoading: false,
            schema: {},
            payarcsettings: [],
            addForm: false,
            selectedPayarcSetting: {},
            columns: [
                {
                    field: 'payarcMerchantId',
                    headerName: 'Payarc Merchant ID',
                    minWidth: 200,
                    editable: false
                },
                {
                    field: 'payarcEmail',
                    headerName: 'Payarc Email',
                    minWidth: 300,
                    editable: false
                },
                {
                    field: 'DeviceSerialNo',
                    headerName: 'Device Serial Number',
                    minWidth: 200,
                    editable: false
                },
                {
    field: 'actions',
    headerName: 'Actions',
    minWidth: 300,
    editable: false,
    renderCell: () => (
        <FButton
            variant="contained"
            size="small"
            onClick={this.handleToggleView}
            label={
                this.state.selectedPayarcSetting.hasOwnProperty('payarcMerchantId')
                    ? "Edit"
                    : "Add"
            }
        />
    )
}

            ]
        };

        this.handleCloseform = this.handleCloseform.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.handleToggleView = this.handleToggleView.bind(this);
    }

    componentDidMount() {
        this.setState({ schema }, () => {
            this.reloadData();
        });
    }

    // ================= LOAD DATA =================
    reloadData() {
        this.httpManager
            .postRequest(`merchant/payarcsettings/get`, {
                merchantId: this.props.merchant.merchantId
            })
            .then(response => {
                let setting = {};
                setting.merchantId = this.props.merchant.merchantId;

                if (response.data.length > 0) {
                    setting = { ...setting, ...response.data[0] };
                } else {
                    setting.id = () => Math.floor(Math.random() * 3);
                }

                this.setState({ selectedPayarcSetting: setting }, () => {
                    this.setState({ payarcsettings: [setting] });
                });
            });
    }

    // ================= ADD / EDIT TOGGLE =================
    handleToggleView() {
        this.setState({ isLoading: true }, () => {
            if (this.state.selectedPayarcSetting.hasOwnProperty('payarcMerchantId')) {
                this.openEdit(this.state.selectedPayarcSetting, () => {
                    this.setState({ addForm: true });
                });
            } else {
                this.openAdd(() => {
                    this.setState({ addForm: true });
                });
            }
        });
    }

    handleCloseform() {
        this.setState({ addForm: false });
    }

    // ================= EDIT =================
    openEdit(data, callback) {
        const schemaCopy = { ...this.state.schema };
        const properties = [...this.state.schema.properties];

        const updatedProperties = properties.map(field => ({
            ...field,
            value: data[field.name] ?? ""
        }));

        updatedProperties.push({
            component: "TextField",
            type: "hidden",
            minLength: 1,
            maxLength: 100,
            grid: 6,
            name: "merchantId",
            label: "Merchant ID",
            placeholder: "Merchant ID",
            value: this.props.merchant.merchantId
        });

        schemaCopy.properties = updatedProperties;
        schemaCopy.force = true;

        this.setState(
            { schema: schemaCopy, selectedPayarcSetting: data, isLoading: false },
            () => typeof callback === "function" && callback()
        );
    }

    // ================= ADD =================
    openAdd(callback) {
        const schemaCopy = { ...schema };
        const properties = [...schemaCopy.properties];

        const updatedProperties = properties.map(field => ({
            ...field,
            value: ""
        }));

        updatedProperties.push({
            component: "TextField",
            type: "hidden",
            minLength: 1,
            maxLength: 100,
            grid: 6,
            name: "merchantId",
            label: "Merchant ID",
            placeholder: "Merchant ID",
            value: this.props.merchant.merchantId
        });

        schemaCopy.properties = updatedProperties;
        schemaCopy.force = true;

        

        this.setState(
            {
                schema: schemaCopy,
                selectedPayarcSetting: {},
                isLoading: false
            },
            () => typeof callback === "function" && callback()
        );
    }

    // ================= RENDER =================
    render() {
        return (
            <Page title="Payarc Settings | Astro POS">
                {this.state.isLoading && <Loader show />}

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar
                    pauseOnHover={false}
                />

                {!this.state.addForm && (
                    <Container maxWidth="xl">
                        <Card>
                            <TableView
                                data={this.state.payarcsettings}
                                columns={this.state.columns}
                            />
                        </Card>

                        <Box sx={{ width: '100%' }}>
                            <Grid
                                container
                                spacing={7}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <FButton
                                    variant="contained"
                                    label="Close"
                                    size="large"
                                    onClick={() => this.props.closeForm()}
                                />
                            </Grid>
                        </Box>
                    </Container>
                )}

                {this.state.addForm && (
                    <Box sx={{ width: '100%' }}>
                        <Grid
                            container
                            spacing={4}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Grid item xs={12}>
                                <Stack spacing={3}>
                                    <FormManager
                                        formProps={this.state.schema}
                                        closeForm={this.handleCloseform}
                                        reloadData={() => {
                                            this.setState({ addForm: false }, () => {
                                                this.reloadData();
                                            });
                                        }}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Page>
        );
    }
}
